import { combineReducers } from "@reduxjs/toolkit";
import transactionsUser from "./transactionsSlice";

const reducer = combineReducers({
	transactionsUser,
});

export default reducer;
